<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Edit Batch Entries</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <EditBulkEntriesForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import EditBulkEntriesForm from "../../components/Kleyton/Forms/Journal/EditBulkEntriesForm";

export default {
  page: {
    title: "Edit Batch Entries",
    meta: [{ name: "Edit Batch Entries", content: window.__env.app.description }]
  },

  components: {
    EditBulkEntriesForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "EditBatchEntries",
      title: "Edit Batch Entries",
      items: [
        {
          text: "Batch",
          href: "/"
        },
        {
          text: "Edit Batch Entries",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
